import { Timestamp } from '@bufbuild/protobuf/wkt'

import { Signal } from '@/gen/inventory/v1/signal_pb'

import { formatTimestamp } from '@/lib/date/date'
import { cn } from '@/lib/ui/style-helpers'

type DateCellProps = {
  data?: Signal
}

export const DateCell = ({ data }: DateCellProps) => {
  return <DateCellComponent date={data?.detectionTime} />
}

export const DateCellComponent = ({
  date,
  className,
}: {
  date?: Timestamp
  className?: string
}) => {
  if (!date) {
    return <div className='text-muted-foreground'>-</div>
  }

  return (
    <span className={cn('text-nowrap text-main-foreground-primary text-body-default', className)}>
      {formatTimestamp(date)}
    </span>
  )
}
